<div class="auth-page auth-page--flow">
  <div class="auth-page__grid">
    <aside class="auth-showcase" aria-hidden="true">
      <div class="auth-showcase__inner">
        <div class="auth-showcase__mockup">
          <div class="auth-showcase__mockup-bar">
            <span class="auth-showcase__mockup-dot"></span>
            <span class="auth-showcase__mockup-dot"></span>
            <span class="auth-showcase__mockup-dot"></span>
          </div>
          <div class="auth-showcase__mockup-body">
            <img
              src="/assets/images/logos/logo-icon.svg"
              class="auth-showcase__mockup-logo"
              alt=""
            />
            <span class="auth-showcase__mockup-chip">{{ 'auth.showcase.chip' | translate }}</span>
          </div>
        </div>

        <div class="auth-showcase__slides">
          <div class="auth-showcase__slide">
            <h2 class="auth-showcase__title">{{ 'auth.showcase.slide1Title' | translate }}</h2>
            <p class="auth-showcase__body">{{ 'auth.showcase.slide1Body' | translate }}</p>
          </div>
          <div class="auth-showcase__slide">
            <h2 class="auth-showcase__title">{{ 'auth.showcase.slide2Title' | translate }}</h2>
            <p class="auth-showcase__body">{{ 'auth.showcase.slide2Body' | translate }}</p>
          </div>
          <div class="auth-showcase__slide">
            <h2 class="auth-showcase__title">{{ 'auth.showcase.slide3Title' | translate }}</h2>
            <p class="auth-showcase__body">{{ 'auth.showcase.slide3Body' | translate }}</p>
          </div>
        </div>

        <div class="auth-showcase__dots" aria-hidden="true">
          <span class="auth-showcase__dot"></span>
          <span class="auth-showcase__dot"></span>
          <span class="auth-showcase__dot"></span>
        </div>
      </div>
    </aside>

    <main class="auth-main auth-main--flow">
      <div class="auth-main__content">
        <nav class="auth-mobile-nav" [attr.aria-label]="'auth.login.back' | translate">
          <a
            class="auth-back auth-back--icon"
            routerLink="/authentication"
            [attr.aria-label]="'auth.login.back' | translate"
          >
            <i-tabler name="chevron-left" class="auth-back__icon flex"></i-tabler>
          </a>
        </nav>

        <a class="auth-brand" [routerLink]="['/authentication']">
          <img
            src="/assets/images/logos/logo.svg"
            class="auth-brand__logo"
            [attr.alt]="'auth.register.logoAlt' | translate"
          />
        </a>

        <div class="auth-panel">
          <h1 class="auth-panel__title">{{ 'auth.register.title' | translate }}</h1>
          <p class="auth-panel__subtitle">
            {{
              (claimBusinessName ? 'auth.register.claimSubtitle' : 'auth.register.subtitle')
                | translate
            }}
          </p>

          @if (claimBusinessName) {
            <div class="auth-info-banner auth-info-banner--claim" role="status">
              <mat-icon class="auth-info-banner__icon" aria-hidden="true">storefront</mat-icon>
              <p class="auth-info-banner__text">
                {{
                  'auth.register.claimBanner'
                    | translate
                      : {
                          name: claimBusinessName,
                          slug: claimSlug || 'tu-negocio',
                        }
                }}
              </p>
            </div>
          } @else {
            <div class="auth-info-banner" role="note">
              <mat-icon class="auth-info-banner__icon" aria-hidden="true">info</mat-icon>
              <p class="auth-info-banner__text">{{ 'auth.register.infoBanner' | translate }}</p>
            </div>
          }

          <app-auth-google-signin-button
            class="auth-google-btn--hub"
            text="signup_with"
            [label]="'auth.register.googleCta' | translate"
            [loadingLabel]="
              isSubmitting
                ? ('auth.register.googleSubmitting' | translate)
                : ('auth.register.googleLoading' | translate)
            "
            [visible]="showGoogleSignIn"
            [loading]="googleAuthInitializing || isSubmitting"
          />

          <div class="auth-divider">{{ 'auth.register.divider' | translate }}</div>

          <form class="auth-form" [formGroup]="form" (ngSubmit)="submit()">
            <mat-form-field appearance="outline" color="primary" subscriptSizing="dynamic">
              <mat-label>{{ 'auth.register.firstName' | translate }}</mat-label>
              <input matInput formControlName="uname" autocomplete="given-name" />
              @if (showFieldError(f['uname'])) {
                @if (f['uname'].errors?.['required']) {
                  <mat-error>{{ 'auth.register.firstNameRequired' | translate }}</mat-error>
                } @else if (f['uname'].errors?.['minlength']) {
                  <mat-error>{{ 'auth.register.firstNameMinLength' | translate }}</mat-error>
                }
              }
            </mat-form-field>

            <mat-form-field appearance="outline" color="primary" subscriptSizing="dynamic">
              <mat-label>{{ 'auth.register.lastName' | translate }}</mat-label>
              <input matInput formControlName="lname" autocomplete="family-name" />
              @if (showFieldError(f['lname'])) {
                @if (f['lname'].errors?.['required']) {
                  <mat-error>{{ 'auth.register.lastNameRequired' | translate }}</mat-error>
                } @else if (f['lname'].errors?.['minlength']) {
                  <mat-error>{{ 'auth.register.lastNameMinLength' | translate }}</mat-error>
                }
              }
            </mat-form-field>

            <mat-form-field appearance="outline" color="primary" subscriptSizing="dynamic">
              <mat-label>{{ 'auth.register.email' | translate }}</mat-label>
              <input matInput type="email" inputmode="email" autocomplete="email" formControlName="email" />
              @if (showFieldError(f['email']) && f['email'].errors?.['required']) {
                <mat-error>{{ 'auth.register.emailRequired' | translate }}</mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline" color="primary" subscriptSizing="dynamic">
              <mat-label>{{ 'auth.register.password' | translate }}</mat-label>
              <input
                matInput
                [type]="hidePassword ? 'password' : 'text'"
                autocomplete="new-password"
                formControlName="password"
              />
              <button
                mat-icon-button
                matSuffix
                type="button"
                [attr.aria-label]="hidePassword ? 'Mostrar contraseña' : 'Ocultar contraseña'"
                (click)="hidePassword = !hidePassword"
              >
                <mat-icon>{{ hidePassword ? 'visibility' : 'visibility_off' }}</mat-icon>
              </button>
              @if (showFieldError(f['password']) && f['password'].errors?.['required']) {
                <mat-error>{{ 'auth.register.passwordRequired' | translate }}</mat-error>
              }
            </mat-form-field>

            <div class="auth-password-rules" aria-live="polite">
              @for (rule of passwordRules; track rule) {
                <div class="auth-password-rule" [class.auth-password-rule--valid]="passwordMeets(rule)">
                  <mat-icon aria-hidden="true">{{ passwordMeets(rule) ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
                  <span>{{ ('auth.register.passwordRule' + rule) | translate }}</span>
                </div>
              }
            </div>

            <mat-checkbox color="primary" formControlName="legalAccepted">
              {{ 'auth.register.legalLead' | translate }}
              <a routerLink="/legal/terminos" target="_blank" rel="noopener">{{
                'auth.register.legalTerms' | translate
              }}</a>
              {{ 'auth.register.legalAnd' | translate }}
              <a routerLink="/legal/privacidad" target="_blank" rel="noopener">{{
                'auth.register.legalPrivacy' | translate
              }}</a>
            </mat-checkbox>
            @if (showFieldError(f['legalAccepted']) && f['legalAccepted'].errors?.['required']) {
              <mat-error class="auth-legal-error">{{
                'auth.register.legalRequired' | translate
              }}</mat-error>
            }

            @if (errorMessage) {
              <div class="auth-form-error" role="alert">
                <p>{{ errorMessage }}</p>
                @if (emailAlreadyRegistered) {
                  <a
                    class="auth-form-error__cta"
                    [routerLink]="['/authentication/login']"
                    [queryParams]="loginWithCreateBusinessQuery"
                  >
                    {{ 'auth.register.goToLoginCreateBusiness' | translate }}
                  </a>
                }
              </div>
            }

            <button mat-flat-button color="primary" class="auth-btn-primary" type="submit" [disabled]="isSubmitting">
              @if (isSubmitting) {
                {{ 'auth.register.submitting' | translate }}
              } @else {
                {{ 'auth.register.submit' | translate }}
              }
            </button>
          </form>
        </div>

        <p class="auth-footer">
          {{ 'auth.register.loginPrompt' | translate }}
          <a [routerLink]="['/authentication/login']">{{ 'auth.register.loginLink' | translate }}</a>
        </p>
      </div>
    </main>
  </div>
</div>
